import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import DreamUpIcon from '@wix/da-ds/pkg/Icons/24x24/DreamUp';
import { Url } from '@wix/da-url';
import { BiData, type DreamupInfoClickBiEvent } from '@wix/da-bi/pkg/events';

interface Props {}

const CreateWithDreamupButton: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <TextButton
      variant="main"
      icon={DreamUpIcon}
      iconProps={{ branded: true }}
      size="large"
      href={Url.dreamupLink()}
      biData={BiData<DreamupInfoClickBiEvent>({
        evid: 923,
        sectionname: 'playground',
      })}
    >
      {t('studio.header.tabs.playground.cta.dreamup')}
    </TextButton>
  );
};

CreateWithDreamupButton.displayName = 'CreateWithDreamupButton';

export default CreateWithDreamupButton;
